import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import SettingMer from "@/utils/settingMer";
import { isPhone } from "@/libs/wechat";
const service = axios.create({
  baseURL: SettingMer.apiBaseURL,
  timeout: 20000, // 过期时间
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // 发送请求之前做的
    const token = !store.getters.token
      ? sessionStorage.getItem("token")
      : store.getters.token;
    if (token) {
      config.headers["Authori-zation"] = token;
    }
    config.headers["Access-Control-Allow-Origin"] =
      "https://shop.saas.njyjzs.com.cn";
    if (/get/i.test(config.method)) {
      config.params = config.params || {};
      config.params.temp = Date.parse(new Date()) / 1000;
    }
    // 添加请求来源标识
    config.headers["requestSource"] = "internet";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 401) {
      // to re-login
      const text = "登录信息过期或账号存在重复登录，请重新登录！";
      // const text = '本系统已升级，请转至operator端进行操作'

      MessageBox.confirm(text, "退出", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          store.dispatch("user/resetToken").then(() => {
            window.location.href = "/login";
          });
        })
        .catch((err) => {
          store.dispatch("user/resetToken").then(() => {
            window.location.href = "/login";
          });
        });
      return Promise.reject("error");
    }
    if (res.code === 403) {
      // to re-login
      MessageBox.confirm("您没有该接口的权限", "退出", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          store.dispatch("user/resetToken").then(() => {
            window.location.href = "/login";
          });
        })
        .catch((err) => {
          store.dispatch("user/resetToken").then(() => {
            window.location.href = "/login";
          });
        });
      return Promise.reject("error");
    }
    if (res.code !== 200 && res.code !== 401) {
      if (isPhone()) {
        //移动端
        return Promise.reject(res || "Error");
      }
      Message({
        message: res.message || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject();
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res.data;
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
